var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tools-icon tools-time"},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.timer)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }